import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import { DadosPessoaisAba1DTO } from "../../model/dadoaPessoaisAba1.dto";
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { ArquivoBlobDTO } from "../../model/arquivoBlob.dto";

@Injectable()
export class DadosPessoaisAba1 extends GenericService {
    private path = environment.url + 'api/v1';

    constructor(http: HttpClient) {
        super(http);
    }

    getDadosPessoais(): Observable<DadosPessoaisAba1DTO> {
        return this.http.get<DadosPessoaisAba1DTO>(this.path + '/dados-pessoais');
    }

    atualizarDadosPessoais(data): Observable<any> {
        return this.http.put(this.path + '/dados-pessoais', data);
    }

    visualizarComprovanteGrauEscolaridade() {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.get<ArquivoBlobDTO>( this.path + `/visualizar_comprovante/grau_escolaridade`, options);
    }

    visualizarComprovanteConjuge() {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.get<ArquivoBlobDTO>(this.path + `/visualizar_comprovante/conjuge`, options);
    }

    visualizarComprovanteEstadoCivil(): Observable<ArquivoBlobDTO> {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.get<ArquivoBlobDTO>( this.path + `/visualizar_comprovante/estado_civil`, options);
    }
    deletarComprovanteEstadoCivil(): Observable<ArquivoBlobDTO> {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.put<ArquivoBlobDTO>(this.path + `/comprovante-deletar/estado_civil`, options);
    }
    deletarComprovanteConjuge() {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.put<ArquivoBlobDTO>(this.path + `/comprovante-deletar/conjuge`, options);
    }
    deletarComprovanteGrauEscolaridade() {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.put<ArquivoBlobDTO>(this.path + `/comprovante-deletar/grau_escolaridade`, options);
    }
}